import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/lib/axios";

export const sendChat = createAsyncThunk(
  "chatLoading/sendChat",
  async (args: { text: string; sessionId: string | null; messageId: string, userId: string | null }, thunkAPI) => {
    try {
      const q = encodeURIComponent(args.text);
      const sessionParam = args.sessionId === null
        ? "session_id=null"
        : `session_id=${encodeURIComponent(args.sessionId)}`;
      const url = `/chat?query=${q}&${sessionParam}&user_id=${encodeURIComponent(args.userId ?? "")}`;
      const res = await axiosInstance.post(url, null, {
        responseType: "json",
        // @ts-expect-error for custom middleware
        meta: { skipLoader: true },
      });

      const json = res.data;
      const responseText =
        json?.data?.response ||
        json?.response ||
        json?.message ||
        (typeof json === "string" ? json : "");
      const payload = json?.data ?? json;
      const returnedSessionId =
        json?.data?.session_id || json?.session_id || json?.meta?.session_id || null;

      return { responseText, payload, returnedSessionId, messageId: args.messageId };
    } catch (err) {
      return thunkAPI.rejectWithValue({ message: "Failed to fetch results. See console." });
    }
  }
);

const initialState = {
  loading: false,
  statusMessages: [
    "Analyzing and Interpreting your request..",
    "Reviewing safety data relationships…",
    "Crunching the data safely and precisely…",
    "Just a moment… structuring query logic…",
    "Optimizing SQL joins for accurate counts…",
    "Compiling your custom PV insights…",
    "Almost done… synthesizing results…",
  ],
};

const chatLoadingSlice = createSlice({
  name: "chatLoading",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sendChat.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sendChat.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(sendChat.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setLoading } = chatLoadingSlice.actions;
export default chatLoadingSlice.reducer;
export const selectIsLoading = (s: any) => s.chatLoading?.loading ?? false;
export const selectStatusMessages = (s: any) => s.chatLoading?.statusMessages ?? [];
